import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'VideoTopics';

const VideoTopicsApi: any = baseApi(endpoint);

export default VideoTopicsApi;